import React from 'react';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    List,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { ExpandMore } from '@mui/icons-material';
import { RootState } from '../../../Redux/Reducers/RootReducer';
import INotificationState from '../../../Redux/Models/Notification/INotificationState';
import { updateNotification } from '../../../Redux/Reducers/NotificationSlice';
import CustomTypography, {
    TypographyType,
} from '../../Typography/CustomTypography';
import './AlertMessageStyle.scss';
import { NotificationCloseHandlerType } from '../../../Redux/Models/Notification/NotificationCloseHandlerType';
import { goToUrl } from '../../../Utils/NavigationUtils';
import AuthService from '../../../Services/Authentication/AuthService';

function AlertMessagePopUp(): JSX.Element {
    const notificationState = useSelector(
        (state: RootState) => state.notification
    ) as INotificationState;
    const { alertMessage } = notificationState;
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const currentURL = window.location.toString();
    const handleClose = async (index: number) => {
        if (
            alertMessage &&
            alertMessage.userSelections &&
            alertMessage.userSelections[index] &&
            alertMessage.userSelections[index].action !==
                NotificationCloseHandlerType.Init
        ) {
            switch (alertMessage.userSelections[index].action) {
                case NotificationCloseHandlerType.Reload:
                    await window.location.reload();
                    break;
                case NotificationCloseHandlerType.UserAccountDeletedExit:
                    if (currentURL.includes('fitting')) {
                        AuthService.adB2cInstance.invalidUserLogout();
                        goToUrl(`appexit:fitting/fail/user-account-deleted`);
                    } else if (currentURL.includes('finetuning')) {
                        AuthService.adB2cInstance.invalidUserLogout();
                        goToUrl(`appexit:finetuning/fail/user-account-deleted`);
                    } else {
                        AuthService.adB2cInstance.logout();
                    }
                    break;
                default:
                    break;
            }
        }
        dispatch(
            updateNotification({
                ...notificationState,
                alertMessage: {
                    title: alertMessage.title,
                    message: alertMessage.message,
                    detailMessage: alertMessage.detailMessage,
                    userSelections: alertMessage.userSelections,
                    isDisplayed: false,
                },
            })
        );
    };

    return (
        <Dialog
            open={alertMessage.isDisplayed}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {alertMessage.title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {alertMessage.message}
                </DialogContentText>
                {alertMessage.detailMessage ? (
                    <Accordion>
                        <AccordionSummary expandIcon={<ExpandMore />}>
                            <CustomTypography
                                type={TypographyType.notoSansBody}
                                text={t(
                                    'common:Common_Feature:ErrorHandling:Text3'
                                )}
                                textAlign="left"
                            />
                        </AccordionSummary>
                        <AccordionDetails>
                            <CustomTypography
                                type={TypographyType.notoSansBody}
                                text={alertMessage.detailMessage}
                                textAlign="left"
                            />
                        </AccordionDetails>
                    </Accordion>
                ) : (
                    <></>
                )}
            </DialogContent>
            <DialogActions>
                <List>
                    {alertMessage?.userSelections?.map(
                        (x: { content: string }, index: number) => {
                            return (
                                <Button
                                    key={`selection-${x.content}`}
                                    id={`selection-${x.content}`}
                                    color="primary"
                                    onClick={() => {
                                        handleClose(index);
                                    }}
                                >
                                    {x.content}
                                </Button>
                            );
                        }
                    )}
                </List>
            </DialogActions>
        </Dialog>
    );
}

export default AlertMessagePopUp;
